import React, { useEffect, useState } from 'react';
import { inputs } from '@ecosystem/newron-design-system';

import { DateRangeConfigItem } from '../types';
import { ConfigItemElementProps } from './types';

const DEFAULT_LOCALE = 'en-GB';

const { MonthPicker } = inputs;

function formatMonthYear(date: Date): string {
  return new Intl.DateTimeFormat(DEFAULT_LOCALE, {
    month: 'short',
    year: 'numeric',
  }).format(date);
}

function DateRangeElement({
  configItem: { key, label, options, value, tooltipInfo, disabled },
  onChange,
}: ConfigItemElementProps<DateRangeConfigItem>) {
  const { min: minOption, max: maxOption } = options || {};

  const [start, setStart] = useState<Date>(value?.min ?? null);
  const [end, setEnd] = useState<Date>(value?.max ?? null);
  const [helperText, setHelperText] = useState<string>('');

  useEffect(() => {
    setStart(value?.min ?? null);
    setEnd(value?.max ?? null);
  }, [value?.min, value?.max]);

  useEffect(() => {
    const helperTexts = [];

    if (minOption) {
      helperTexts.push(`Min: ${formatMonthYear(minOption)}`);
    }

    if (maxOption) {
      helperTexts.push(`Max: ${formatMonthYear(maxOption)}`);
    }

    setHelperText(helperTexts.join(', '));
  }, [minOption, maxOption]);

  const handleChange = ([startDate, endDate]: [Date, Date]) => {
    onChange(key, { min: startDate, max: endDate });
  };

  return (
    <div className="relative">
      <MonthPicker
        isRange
        defaultDates={[start, end]}
        onChange={handleChange}
        helperText={helperText}
        label={label}
        minDate={minOption}
        maxDate={maxOption}
        disabled={disabled}
        value={[start, end]}
        dateFormat={'MMM yyyy' as inputs.MonthFormatType}
        tooltipInfo={tooltipInfo}
        tooltipPlacement="top"
      />
    </div>
  );
}

export { DateRangeElement };
